import { render, staticRenderFns } from "./StructuresEdit.vue?vue&type=template&id=7fffc2d7&"
import script from "./StructuresEdit.vue?vue&type=script&lang=ts&"
export * from "./StructuresEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports